module.exports = __webpack_public_path__ + "static/media/mmFront3.08013d8d.jpg";